export const C = {
  surface: "#121212",
  surface2: "#1E1E1E",
  surface3: "#2A2A2A",
  onSurface: "#FFFFFF",
  brand: "#D4AF37",
  brand2: "#F3E5AB",
  brand3: "#292415",
  success: "#27AE60",
  warning: "#F2994A",
  error: "#EB5757",
  silver: "#C0C0C0",
  bronze: "#CD7F32",
  muted: "#9E9E9E",
  border: "#333333",
  borderStrong: "#555555",
};

export const eur = (v) =>
  `${(v ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: Number.isInteger(v ?? 0) ? 0 : 2, maximumFractionDigits: 2 })} €`;

export const date = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const dateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

export const STATUSES = ["recu", "contacte", "etudie", "devis", "signe", "commission_validee", "commission_payee"];

export const STATUS_LABELS = {
  recu: "Recommandation reçue",
  contacte: "Prospect contacté",
  etudie: "Projet étudié",
  devis: "Devis transmis",
  signe: "Contrat signé",
  commission_validee: "Commission validée",
  commission_payee: "Commission payée",
};

export function statusColor(s) {
  switch (s) {
    case "recu":
      return C.silver;
    case "contacte":
      return C.brand2;
    case "etudie":
    case "devis":
      return C.brand;
    default:
      return C.success;
  }
}

export const COMMISSION_LABELS = {
  pending: "En attente de validation",
  validated: "Validée",
  paid: "Payée",
};

export const commissionColor = (s) => (s === "paid" ? C.success : s === "validated" ? C.brand : C.warning);

export const PROJECT_LABELS = {
  construction: "Construction neuve",
  renovation: "Rénovation",
};

export const SERVICE_TYPES = {
  construction: ["Construction clé en main", "Maîtrise d'œuvre", "Extension", "Autre"],
  renovation: ["Rénovation complète", "Rénovation énergétique", "Extension", "Aménagement intérieur", "Autre"],
};

export const pct = (p) => `${String(p).replace(".", ",")} %`;
